import {
	Id,
	LaravelResponse,
	PaginatedListFetcherConfig,
	keyToUrl,
	mapPaginatedFetcherConfigToAxiosConfig,
	withDestroyEndpoint,
	withShowEndpoint,
	withUpdateEndpoint,
} from "@dgs/core";
import axios from "axios";
import { IContactOptionResource } from "../types";
import {
	AttachContactsToInvitationListBulkRequest,
	IInvitationListAttachMultiContactsContactRequest,
	IInvitationListAttachSingleContactRequest,
	IInvitationListIndexResource,
	IInvitationListShowResource,
	InvitationListStats,
} from "../types/invitationList";

export const invitationListKeyItem = "invitation-list";

const createBaseInvitationListService = (eventId: Id, baseKeyPrefix = ["events"]) => {
	const baseKey = [...baseKeyPrefix, `${eventId}`, "invitation-list"];
	const contactOptionsKey = [...baseKey, "contacts", "available-options"];

	return {
		...withShowEndpoint<IInvitationListShowResource>(baseKey),
		...withUpdateEndpoint<IInvitationListAttachSingleContactRequest>(baseKey),
		...withDestroyEndpoint(baseKey),
		attachContacts: (request: IInvitationListAttachMultiContactsContactRequest) => {
			return axios.put(keyToUrl([...baseKey, "attach-contacts"]), request);
		},
		attachContactsByBulkEdit: (request: AttachContactsToInvitationListBulkRequest) =>
			axios.put(keyToUrl([...baseKey, "attach-contacts-by-bulk-edit"]), request),
		getStats: () => axios.get<LaravelResponse<InvitationListStats>>(keyToUrl([...baseKey, "stats"])),
		indexKey: baseKey,
		listKey: [...baseKey, "list"],
		index: (config: PaginatedListFetcherConfig<IInvitationListIndexResource>, contactViewId: Id | null) => {
			const axiosConfig = mapPaginatedFetcherConfigToAxiosConfig(config);

			return axios.get<LaravelResponse<IInvitationListIndexResource[]>>(keyToUrl(baseKey), {
				...axiosConfig,
				params: {
					...axiosConfig.params,
					sort: config.sortParams
						? {
								[["personCount", "attendancePrediction"].includes(config.sortParams.column)
									? "customContactAttributeName"
									: "contactAttributeId"]: config.sortParams.column,
								direction: config.sortParams.direction,
							}
						: null,
					contactViewId,
				},
			});
		},
		contactOptionsKey: contactOptionsKey,
		contactOptions: (search?: string, page?: number) =>
			axios.get<LaravelResponse<IContactOptionResource[]>>(keyToUrl(contactOptionsKey), {
				params: { search, page },
			}),
	};
};

export type IInvitationListEndpoints = ReturnType<typeof createBaseInvitationListService>;

export const createArchivedEventInvitationListService = (eventId: Id) => {
	return createBaseInvitationListService(eventId, ["events", "archived"]);
};

export const createInvitationListService = (eventId: Id) => {
	return createBaseInvitationListService(eventId);
};
